import React, { useState } from 'react';

import {
  Flex, FlexProps, HStack, Image,
} from '@chakra-ui/react';

import CarouselModal from 'containers/Modals/Carrousel';

import { Icon } from '../icon';

interface CarouselProps extends FlexProps {
    images?: any[]
}

export default function Carousel({
  images,
  ...rest
}: CarouselProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [counter, setCounter] = useState(0);
  const amount = images?.length > 6 ? 6 : images?.length;

  const increment = () => {
    setCounter((prev) => (prev + amount > images?.length ? 1 : prev + 1));
  };

  const decrement = () => {
    setCounter((prev) => (prev > 0 ? prev - 1 : images?.length - amount));
  };

  return (
    <Flex
      maxW="70%"
      {...rest}>
      <CarouselModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        images={images}
      />
      <HStack>
        <Icon
          onClick={increment}
          cursor="pointer"
          name="angle-left"
          color="gray.500"
        />
        {images?.slice(counter, counter + amount)?.map((url) => (
          <Image
            onClick={() => setOpenModal(true)}
            key={url}
            borderRadius={4}
            width="70px"
            height="70px"
            src={url}
          />
        ))}
        <Icon
          onClick={decrement}
          cursor="pointer"
          name="angle-right"
          color="gray.500"
        />
      </HStack>
    </Flex>
  );
}
